import V from 'vue'
import {cleanObj, debugLog, msg} from 'vue-src/utils'
import Tracking from 'vue-src/utils/tracking'
import {IxApi, IxDelete, IxFetch, IxPatch, IxPost, testTokenScope} from 'vue-src/IxPlugin/api'
import IxAddress from 'vue-src/classes/ix-address'
import CONSTANTS from 'vue-src/components/global/constants.js'

function oopsieDaisy(r) {
  // msg.danger('Oops! something went wrong! status code:' + r.status)
  debugLog(r)
  return Promise.reject(r)
}


const ajv = new window.Ajv({allErrors: true})
const validation = CONSTANTS.CART_VALIDATION

const validate = ajv.compile(validation)

function indexByStockNumber(line_items, stock_number) {
  let index = undefined

  function findTheStockNumber(e, i, a) {
    if (e.stock_number == stock_number) index = i
  }

  line_items.map(findTheStockNumber)
  return index
}

function scrubLineItemData(data) {
  if (typeof data.quantity !== 'undefined') data.quantity = parseFloat(data.quantity)
  if (typeof data.price !== 'undefined') data.price = parseFloat(data.price)
  return data
}

let state = function () {
  return {
    cart_promise: null,
    added: {},
    line_items: [],
    checkoutStatus: null,
    shipping_cost: 14,
    cart_id: undefined,
    cart_obj: {
      lineitems_count: 0,
      lineitems_recent: []
    },
    all_lineitems: [],
    cart_loading: false,
    tax_quote_loading: false,
    ship_quote_loading: false,
    tax_quote_tbd: false,
    full_refresh: false,
    shipping_methods: [],
    local_errors: [],
    remote_errors: {},
  }
}

export const getters = {
  getLocalCartItems(state) {
    return state.line_items
  },
  getLocalCartTotal(state) {
    return parseFloat(state.cart_obj.cart_total)
  },
  getLocalCartCharges(state) {
    return state.cart_obj.conditional_charges.map(charge => {
      return {
        ...charge,
        amount: parseFloat(charge.amount),
      }
    })
  },
  getLocalCartSubTotal(state) {
    return parseFloat(state.cart_obj.subtotal)
  },
  getLocalCartTaxes(state) {
    return parseFloat(state.cart_obj.tax_amount)
  },
  getLocalCartProductsCount(state) {
    return state.cart_obj.lineitems_count
  },
  getAllLineitems(state) {
    return state.all_lineitems
  },
  getLocalCartShipping(state) {
    return parseFloat(state.cart_obj.estimated_shipping)
  },
  getRemoteCartErrors(state){
    return state.remote_errors
  },
  getLocalCartObject(state) {
    return state.cart_obj
  },
  getLocalCartBillTo(state){
    if(state.cart_obj.addresses) return state.cart_obj.addresses.billto
    return new IxAddress({'address_type':'billto'})
  },
  getLocalCartShipTo(state){
    if(state.cart_obj.addresses) return state.cart_obj.addresses.shipto
    return new IxAddress({'address_type':'shipto'})
  },
  getCartLineItemsUrl(state) {
    return state.cart_obj.lineitems
  },
  showCart(state) {
    return state.cart_obj.lineitems_count > 0 && !state.cart_loading
  },
  showFullCart(state) {
    return state.cart_obj.lineitems_count > 0
  },
  cartLoading(state) {
    return state.cart_loading
  },
  taxQuoteLoading(state) {
    return state.tax_quote_loading
  },
  shipQuoteLoading(state) {
    return state.ship_quote_loading
  },
  taxQuoteTBD(state) {
    return state.tax_quote_tbd
  },
  fullCartLoading(state) {
    return state.full_refresh
  },
  currentShippingMethod(state) {
    let shipping_method =
        state.shipping_methods.filter(e => e.id === state.cart_obj.shipping_method)
    if (shipping_method.length > 0) {
      return shipping_method[0]
    }
    return {
      description: 'None',
      id: null,
      price: 0,
    }
  },
  listShippingMethods(state) {
    return state.shipping_methods
  },
}

const mutations = {
  setCartContactEmail(state, payload) {
    state.cart_obj.contact_email = payload
  },
  setCartContactName(state, payload) {
    state.cart_obj.contact_name = payload
  },
  setCartContactPhone(state, payload) {
    state.cart_obj.contact_phone = payload
  },
  setCartCustomerPO(state, payload) {
    state.cart_obj.customer_po = payload
  },
  setCartComments(state, payload) {
    state.cart_obj.comments = payload
  },
  setAllLineitems(state, payload) {
    state.all_lineitems = payload
  },
  setCartDescription(state, payload) {
    state.cart_obj.description = payload
  },
  setLocalCartErrors(state, payload) {
    state.local_errors = payload
  },
  setRemoteCartErrors(state, payload) {
    let keys = Object.keys(payload)
    keys.forEach(e=>V.set(state.remote_errors, e, payload[e]))
  },
  setShipToAddressUrl(state, payload) {
    state.cart_obj.ship_to_address = payload
  },
  setBillToAddressUrl(state, payload) {
    state.cart_obj.bill_to_address = payload
  },
  addProductToLocalCart(state, payload) {
    payload = scrubLineItemData(payload)
    V.set(state.line_items, state.line_items.length, payload)
  },
  incrementLocalCartQuantity(state, payload) {
    payload = scrubLineItemData(payload)
    const ItemIndex = indexByStockNumber(state.line_items, payload.stock_number),
        oldQuantity = state.line_items[ItemIndex].quantity,
        newQuantity = payload.quantity,
        newPayload = cleanObj(payload)
    newPayload.quantity = oldQuantity + newQuantity
    if (newPayload.quantity < 0) newPayload.quantity = 0
    V.set(state.line_items, ItemIndex, newPayload)
  },
  updateLocalCartQuantity(state, payload) {
    payload = scrubLineItemData(payload)
    debugLog(payload)
    const ItemIndex = indexByStockNumber(state.line_items, payload.stock_number),
        newQuantity = payload.quantity,
        newPayload = cleanObj(payload)

    if (newQuantity < 0) newPayload.quantity = 0
    else newPayload.quantity = newQuantity

    V.set(state.line_items, ItemIndex, newPayload)
  },
  removeProductFromLocalCart(state, stock_number) {
    let newLineItems = cleanObj(state.line_items),
        index = indexByStockNumber(state.line_items, stock_number)
    newLineItems.splice(index, 1)
    V.set(state, 'line_items', newLineItems)
  },
  updateLocalCartObject(state, payload) {
    if (typeof payload.lineitems_count === 'undefined') {
      payload.lineitems_count = 0
      payload.lineitems_recent = []
    }
    V.set(state, 'cart_obj', payload)
  },
  emptyLocalCart(state) {
    V.set(state, 'added', {})
    V.set(state, 'line_items', [])
    V.set(state, 'cart_obj', {})
  },
  setCartLoading(state) {
    state.cart_loading = true
  },
  setCartLoaded(state) {
    state.cart_loading = false
  },
  setTaxQuoteLoading(state, payload) {
    state.tax_quote_loading = payload
  },
  setShipQuoteLoading(state, payload) {
    state.ship_quote_loading = payload
  },
  setTaxQuoteTBD(state, payload) {
    state.tax_quote_tbd = payload
  },
  setFullRefresh(state) {
    state.full_refresh = true
  },
  setFullRefreshed(state) {
    state.full_refresh = false
  },
  setCartPromise(state, promise) {
    state.cart_promise = promise
  },
  setShippingMethods(state, methods) {
    state.shipping_methods = methods
  }
}

const actions = {
  addProductToCart: function ({commit, state, dispatch}, payload) {
    let localCart = state.added,
        lineItem = {
          stock_number: payload.stock_number,
          location_number: payload.location_number,
          quantity: payload.quantity,
        },
        index = indexByStockNumber(state.line_items, payload.stock_number)
    if(state.cart_obj.lineitems_count === 0 ){
       Tracking.CartCreate()
    }
    if (typeof index !== 'undefined') {
      let endpoint = state.line_items[index].url
      return IxPatch(endpoint, lineItem)
          .then(data => dispatch('forceCartReprice'))
    }
    if (typeof state.cart_obj.url === 'undefined') {
      return IxPost(IxApi.carts, {})
          .then(data => {
            commit('updateLocalCartObject', data.data)
            return Promise.resolve(data)
          })
          .then((data) => {
            debugLog(data)
            return IxPost(data.data.lineitems, lineItem)
          })
          .then(data => dispatch('forceCartReprice'))
    } else {
      return IxPost(state.cart_obj.lineitems, lineItem)
          .then(data => dispatch('forceCartReprice'))
    }


  },
  removeProductFromCart: function ({commit, state, dispatch}, stock_number) {
    let localCart = state.line_items,
        index = indexByStockNumber(localCart, stock_number)
    debugLog(index)
    debugLog(stock_number)
    if (typeof index !== 'undefined') {
      return IxDelete(localCart[index].url)
          .then(() => commit('removeProductFromLocalCart', stock_number))
          .then(data => dispatch('forceCartReprice'))
          .catch(data => dispatch('handleBadCart', data))
    }
  },
  setTaxQuoteLoading({commit}, is_loading) {
    commit('setTaxQuoteLoading', is_loading)
  },
  setTaxQuoteTBD({commit}, is_tbd) {
    commit('setTaxQuoteTBD', is_tbd)
  },
  setShipQuoteLoading({commit}, is_loading) {
    commit('setShipQuoteLoading', is_loading)
  },
  removeProductFromCartDropdown: function ({commit, state, dispatch}, stock_number) {
    let localCart = state.cart_obj.lineitems_recent,
        index = indexByStockNumber(localCart, stock_number)
    if (typeof index !== 'undefined') {
      return IxDelete(localCart[index].url)
          .then(data => dispatch('forceCartReprice'))
          .catch(data => dispatch('handleBadCart', data))
    }
  },
  updateCartQuantity({commit, state, dispatch}, {product, amount}) {
    let cleanProduct = cleanObj(product),
        cleanAmount = parseInt(amount),
        payload = {
          stock_number: cleanProduct.stock_number,
          location_number: cleanProduct.location_number,
          quantity: cleanAmount,
          cart:state.cart_obj.url,
        },
        index = indexByStockNumber(state.line_items, cleanProduct.stock_number)
    debugLog(cleanAmount)
    if (typeof cleanAmount !== 'number' || isNaN(cleanAmount)) cleanAmount = 0
    payload.quantity = cleanAmount
    return IxPatch(state.line_items[index].url, payload)
        .then(data => commit('updateLocalCartQuantity', data.data))
        .then(data => dispatch('forceCartReprice'))
        .catch(data => dispatch('handleBadCart', data))
  },
  incrementCartQuantity({commit, state, dispatch}, {product, amount}) {
    let index = indexByStockNumber(state.line_items, product.stock_number),
        currentLItem = state.line_items[index]
    // payload = {
    //   stock_number: cleanProduct.stock_number,
    //   location_number: cleanProduct.location_number,
    //   quantity: amount + currentLItem.quantity
    // }
    dispatch('updateCartQuantity', {
      product: product,
      amount: amount + currentLItem.quantity
    })
    // return IxPatch(currentLItem.url, payload)
    //     .then(data=>commit('updateLocalCartQuantity',data.data))
    //     .then(data=>dispatch('refreshCartObject'))

  },
  handleRefreshCart({dispatch, commit, state}, response) {
    //commit('emptyLocalCart')
    if (response.status === 200) {
      commit('updateLocalCartObject', response.data)
      return IxFetch(response.data.lineitems)
          .then(response => dispatch('handleUpdateAllLineItems', response))
          .catch(data => dispatch('handleBadCart', data))
    }
    commit('setCartLoaded')

  },
  handleUpdateAllLineItems({dispatch, commit, state}, response) {
    debugLog(response)
    if (response.status === 200) {
      let results = Array.from(response.data.results)
      for (let item in results) {
        commit('addProductToLocalCart', results[item])
      }
      debugLog(response.data.next)
      if (response.data.next) {
        return IxFetch(response.data.next)
            .then(data => dispatch('handleUpdateAllLineItems', data))
            .catch(data => dispatch('handleBadCart', data))
      }
      else {
        commit('setCartLoaded')
        commit('setFullRefreshed')
        return Promise.resolve(response)
      }
    }
    commit('setCartLoaded')
    commit('setFullRefreshed')
  },
  handleBadCart({dispatch, commit, state}, response) {
    debugLog(response)
    commit('setCartLoaded')
    commit('setFullRefreshed')
    //dispatch('emptyCart')
  },
  handleRefreshAllCarts({dispatch, commit, state}, response) {
    if (response.status === 200) {
      let firstCart = response.data.results[0]
      if (typeof firstCart !== 'undefined') {
        response.data = firstCart
        return dispatch('handleRefreshCart', response)
      }
      commit('setCartLoaded')
    }
    commit('setCartLoaded')
  },
  refreshAllLineitems({commit}) {
    IxFetch(`${IxApi.lineitems}?${Date.now()}`).then(response => {
      if (response.status === 200) {
        commit('setAllLineitems', response.data.results)
      }
    })
  },
  refreshCart({dispatch, commit, state, getters}) {
    debugLog(cleanObj(state.cart_obj))
    if (!getters.cartLoading) commit('setCartLoading')
    if (typeof state.cart_obj.url === 'undefined') {
      debugLog('refreshCart: not ready')
      /*return IxFetch(IxApi.carts)
          .then(response=>dispatch('handleRefreshAllCarts', response))
          .catch(response=>dispatch('handleBadCart', response))*/
      setTimeout(function () {
        dispatch('refreshCart')
      }, 100)
      return
    }
    debugLog('refreshCart: ready!')
    commit('setFullRefresh')
    return IxFetch(state.cart_obj.url)
        .then(response => dispatch('handleRefreshCart', response))
        .catch(response => dispatch('handleBadCart', response))

  },
  refreshCartObject({dispatch, commit}) {
    commit('setCartLoading')
    return IxFetch(IxApi.current_cart)
        .then(response => dispatch('handleRefreshCartObject', response))
        .catch(response => dispatch('handleBadCart', response))
  },
  handleRefreshCartObject({dispatch, commit, state}, response) {
    if (response.status === 200 && response.data) {
      commit('updateLocalCartObject', response.data)
    }
    else if (response.status === 201) {
      commit('updateLocalCartObject', response.data)
      commit('setCartLoaded')
      return Promise.resolve(response)
    }
    else {
      return IxPost(IxApi.carts, {})
          .then(r => dispatch('handleRefreshCartObject', r))
    }
    if (!state.full_refresh) {
      commit('setCartLoaded')
    }
  },
  emptyCart: function ({commit}) {
    commit('emptyLocalCart')
  },
  async patchCart({dispatch, commit, state, getters, rootGetters}, payload) {
    let readonly = [
          'lineitems_count',
          'lineitems_recent',
          'cart_total',
          'subtotal',
          'tax_amount',
          'estimated_shipping',
          'is_current',
          'addresses',
        ],
        local_cart = cleanObj(state.cart_obj),
        update_fields = [...readonly,...Object.keys(payload)],
        errors = [],
        remote_error_reset = {}
        validation.properties.customer_po.minLength = rootGetters.poRequired?1:0
    Object.keys(payload).forEach(e=>{
      if(validation.properties[e]) {
        let validate = ajv.compile(validation.properties[e]),
            valid = validate(payload[e])
        if(!valid){
          errors = [
              ...errors,
            ...validate.errors.map(i=>{i.dataPath='.'+e;return i})
          ]

        }
      }
      local_cart[e] = payload[e]
      remote_error_reset[e] = undefined
    })
    commit('setLocalCartErrors', errors)
    commit('setRemoteCartErrors', remote_error_reset)
    commit('updateLocalCartObject', local_cart)
    if(errors.length > 0){
      return false
    }
    local_cart = cleanObj(local_cart)
    try {
      let result = await IxPatch(state.cart_obj.url, payload)
      if(result.status !== 200) throw result
      result = await IxFetch(IxApi.current_cart)
      update_fields.forEach(e=>local_cart[e] = result.data[e])
      commit('updateLocalCartObject', local_cart)
      return result
    } catch(error){
      if(error.status === 400) commit('setRemoteCartErrors', error.data)
      debugLog(error)
    }

  },
  forceCartReprice: function ({dispatch, commit, state}) {
    commit('setCartLoading')
    if (typeof state.cart_obj.url !== 'undefined') {
      return IxFetch(state.cart_obj.url)
          .then(response => dispatch('handleRefreshCartObject', response))
          .catch(response => dispatch('handleBadCart', response))
    }
    else {
      return dispatch('refreshCartObject')
          .then(() => dispatch('forceCartReprice'))
    }
  },
  fetchShippingMethods({dispatch, state}) {
    return state.cart_promise.then(
        () => IxFetch(state.cart_obj.shipping_url)
            .then(r => dispatch('handleFetchShippingMethods', r))
    )
  },
  handleFetchShippingMethods({commit}, response) {
    if (response.status === 200) {
      commit('setShippingMethods', response.data)
    }
  },
  updateShipBillTo({commit}, response) {
    if (response.status == 200) {
      commit('setShipToAddressUrl', response.data.ship_to_address)
      commit('setBillToAddressUrl', response.data.bill_to_address)
    }
    else {
      msg.danger('Oh no, something went wrong updating your address!' +
          ' Status:' + response.status)
      debugLog(response)
    }
  },
  validateLocalCart({state, commit, rootGetters}) {
    validation.properties.customer_po.minLength = rootGetters.poRequired?1:0
    let validate = ajv.compile(validation),
        valid = validate(state.cart_obj)
    commit('setLocalCartErrors', !valid ? validate.errors : [])
    return valid
  },
  initCart: function ({dispatch, commit}) {
    if(testTokenScope('cart.read', 'cart.write')){
      let cart = dispatch('refreshCartObject')
      commit('setCartPromise', cart)
      return cart
    }
    return Promise.resolve(false)
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/cart.js